export const QA_NAME_NEWSBOARD_POST_PROFILE_PAGE = 'newsboardPostProfile'
